import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { PDFDownloadLink } from "@react-pdf/renderer";
import axios from "../../axios";
import StudentPerformancePDF from "./StudentPerformancePDF";
import StudentPerformanceNewPDF from "./StudentPerformanceNewPDF";
import { IP } from "../../internalServer";

function ModelForAssessmentType({
  data,
  setOpen,
  student,
  startDate,
  endDate,
  subjects,
  assessmentTypeId,
  studentAdmissionId,
  matchedSubjects,
}) {
  const [selected, setSelected] = useState([]);
  const [skillsData, setSkillsData] = useState([]);
  const [studentRankData, setStudentRankData] = useState([]);
  const [studentScore, setStudentScore] = useState([]);
  const [subjectWiseData, setSubjectWiseData] = useState([]);
  const [attendanceDetails, setAttendanceDetails] = useState([]);
  const academicYearSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  const [schoolProfileLogo, setSchoolProfileLogo] = useState("");
  const [studentProfileImage, setStudentProfileImage] = useState("");

  const getSkillsData = async () => {
    if (
      !student?.standard?.id ||
      !student?.section?.id ||
      !student?.id ||
      !startDate ||
      !endDate
    )
      return;
    try {
      const res = await axios.get(
        `/api/v1/performance/standard/${student?.standard?.id}/section/${student?.section?.id}/student/${student?.id}/percentageWithSkills/get?startDate=${startDate}&endDate=${endDate}&assessmentEventId=${assessmentTypeId}`,
      );
      res && setSkillsData(res?.data?.data?.data);
    } catch (error) {
      console.log("error", error);
    }
  };
  const getRankData = async () => {
    if (
      !student?.standard?.id ||
      !student?.section?.id ||
      !student?.id ||
      !startDate ||
      !endDate
    )
      return;
    try {
      const res = await axios.get(
        `/api/v1/performance/student/${student?.id}/standard/${student?.standard?.id}/section/${student?.section?.id}/studentsRank/get?startDate=${startDate}&endDate=${endDate}&assessmentEventId=${assessmentTypeId}`,
      );
      res && setStudentRankData(res?.data?.data);
    } catch (error) {
      console.log("error", error);
    }
  };
  const getStudentTotalScore = async () => {
    if (!student?.id || !startDate || !endDate) return;
    try {
      const res = await axios.get(
        `/api/v1/performance/student/${student?.id}/overallAverage/get?startDate=${startDate}&endDate=${endDate}&assessmentEventId=${assessmentTypeId}`,
      );
      res && setStudentScore(res?.data?.data);
    } catch (error) {
      console.log("error", error);
    }
  };
  const getSubjectWiseData = async () => {
    if (!student?.id || selected.length === 0) return;

    try {
      let finalMap = {};

      for (let a of selected) {
        const res = await axios.get(
          `/api/v1/performance/student/${student?.id}/subjectWisePercentage/get`,
          {
            params: {
              startDate,
              endDate,
              assessmentEventId: a.id,
            },
          },
        );

        const data = res?.data?.data || [];

        data.forEach((item) => {
          const subjectName = item.result[0]?.name;

          if (!finalMap[subjectName]) {
            finalMap[subjectName] = {
              subject: subjectName,
              assessments: {},
              total: 0,
            };
          }

          finalMap[subjectName].assessments[a.id] = item.totalObtainedMarks;

          finalMap[subjectName].total += item.totalObtainedMarks;
        });
      }

      setSubjectWiseData(Object.values(finalMap));
    } catch (error) {
      console.log(error);
    }
  };

  const handleGatStudentAttendanceReport = async () => {
    try {
      const resp = await axios.get(
        `/api/v1/leaveMngmt/getStudentDetails?academicSessionId=${academicYearSessionId}&timetableSessionId=${student?.timetableSession?.id}&standardId=${student?.standard?.id}&sectionId=${student?.section?.id}&startDate=${startDate}&endDate=${endDate}&studentId=${student?.id}`,
      );
      setAttendanceDetails(resp?.data?.data);
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    setSchoolProfileLogo(`${IP}${student?.school?.profilePic}`);
    setStudentProfileImage(`${IP}${student?.profile_picture}`);
  }, [student?.school?.profilePic, student?.profile_picture]);

  useEffect(() => {
    getSubjectWiseData();
    handleGatStudentAttendanceReport();
  }, [selected, startDate, endDate, student]);

  const getStudentImage = (student) => {
    if (student?.profile_picture) {
      const cleanPath = student.profile_picture;
      return `${IP}${cleanPath}`; // ✅ Include IP here
    }
    if (student?.gender === "M") {
      return student?.avatar_profile
        ? `/images/Boys/${student.avatar_profile}.webp`
        : `/images/Student_boy_pic.png`;
    }
    if (student?.gender === "F") {
      return student?.avatar_profile
        ? `/images/Girls/${student.avatar_profile}.webp`
        : `/images/Student_girl_pic.png`;
    }
    return `/images/default image.png`;
  };

  useEffect(() => {
    getSkillsData();
    getRankData();
    getStudentTotalScore();
  }, [
    assessmentTypeId,
    startDate,
    endDate,
    student,
    studentAdmissionId,
    subjects,
  ]);
  const handleSelect = (item) => {
    setSelected((prev) => {
      const exists = prev.find((i) => i.id === item.id);

      // remove
      if (exists) {
        const updated = prev.filter((i) => i.id !== item.id);

        // adjust after removal
        if (updated.length === 1) {
          updated[0].weight = 100;
        }

        return updated;
      }

      if (prev.length >= 3) return prev;

      const updated = [...prev, { ...item, weight: 0 }];

      // auto assign
      if (updated.length === 1) {
        updated[0].weight = 100;
      }

      if (updated.length === 2) {
        updated[0].weight = 50;
        updated[1].weight = 50;
      }

      if (updated.length === 3) {
        updated[0].weight = 34;
        updated[1].weight = 33;
        updated[2].weight = 33;
      }

      return updated;
    });
  };
  const handleWeightChange = (id, value) => {
    let val = Number(value);

    setSelected((prev) => {
      let updated = prev.map((item) =>
        item.id === id ? { ...item, weight: val } : item,
      );

      const totalEntered = updated.reduce((sum, i) => sum + i.weight, 0);
      const remaining = 100 - val;

      const others = updated.filter((i) => i.id !== id);

      if (others.length === 1) {
        // 2 items → auto adjust second
        others[0].weight = remaining;
      }

      if (others.length === 2) {
        // 3 items → split remaining
        const split = Math.floor(remaining / 2);
        others[0].weight = split;
        others[1].weight = remaining - split;
      }

      // merge back
      return updated.map((item) => {
        const found = others.find((o) => o.id === item.id);
        return found ? found : item;
      });
    });
  };

  return (
    <div>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.5)",
          backdropFilter: "blur(4px)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 520,
            bgcolor: "#fff",
            borderRadius: "16px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
            p: 3,
            position: "relative",
          }}
        >
          {/* Close */}
          <CloseIcon
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              cursor: "pointer",
              color: "#999",
              "&:hover": { color: "#333" },
            }}
          />

          {/* Title */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2,
              textAlign: "center",
            }}
          >
            Select Assessment Type
          </Typography>

          {/* Subtitle */}
          <Typography
            variant="body2"
            sx={{ textAlign: "center", color: "#666", mb: 3 }}
          >
            Choose up to 3 and assign total weight = 100%
          </Typography>

          {/* List */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {data
              ?.filter((i) => i.isKeyAssessment)
              ?.map((item) => {
                const isChecked = selected.some((s) => s?.id === item?.id);
                const selectedItem = selected.find((s) => s?.id === item?.id);
                return (
                  <Box
                    key={item.id}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 2,
                      borderRadius: "10px",
                      border: "1px solid #eee",
                      transition: "all 0.2s",
                      backgroundColor: isChecked ? "#f9fafb" : "#fff",
                      "&:hover": {
                        borderColor: "#ccc",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      },
                    }}
                  >
                    {/* Left */}
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
                    >
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => handleSelect(item)}
                        style={{
                          width: 16,
                          height: 16,
                          cursor: "pointer",
                        }}
                      />
                      <Typography sx={{ fontWeight: 500 }}>
                        {item.name}
                      </Typography>
                    </Box>

                    {/* Right */}
                    <input
                      type="number"
                      value={selectedItem?.weight || ""}
                      onChange={(e) =>
                        handleWeightChange(item.id, e.target.value)
                      }
                      placeholder="%"
                      style={{
                        width: "70px",
                        padding: "6px 8px",
                        borderRadius: "6px",
                        border: "1px solid #ddd",
                        textAlign: "center",
                        fontWeight: 500,
                      }}
                    />
                  </Box>
                );
              })}
          </Box>

          {/* Footer */}
          <Box
            sx={{
              mt: 3,
              pt: 2,
              borderTop: "1px solid #eee",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontSize: "14px", color: "#555" }}>
              Total:{" "}
              <strong>{selected.reduce((sum, i) => sum + i.weight, 0)}%</strong>
            </Typography>

            <PDFDownloadLink
              document={
                <StudentPerformanceNewPDF
                  student={student}
                  subjects={subjects}
                  assessmentTypeId={assessmentTypeId}
                  skillsData={skillsData}
                  studenRankData={studentRankData}
                  TotalScore={studentScore}
                  subjectWiseData={subjectWiseData}
                  matchedSubjects={matchedSubjects}
                  selected={selected}
                  attendanceDetails={attendanceDetails}
                  schoolProfileLogo={schoolProfileLogo}
                  studentProfileImage={studentProfileImage}
                />
              }
              fileName="student-performance-report.pdf"
            >
              {({ loading }) => (
                <button
                  style={{
                    border: "none",
                    borderRadius: "999px",
                    padding: "10px 28px",
                    background:
                      selected.length > 0 ? "#ff7a00" : "rgb(249, 176, 98)",
                    color: "#fff",
                    cursor: selected.length > 0 ? "pointer" : "not-allowed",
                    fontWeight: 500,
                  }}
                  onClick={() => setOpen(true)}
                  disabled={loading || selected.length === 0}
                >
                  Next
                </button>
              )}
            </PDFDownloadLink>
          </Box>
        </Box>
      </Box>
    </div>
  );
}

export default ModelForAssessmentType;
